import { render } from "./DataDiscrepancy.vue?vue&type=template&id=3700503d&scoped=true&ts=true"
import script from "./DataDiscrepancy.vue?vue&type=script&lang=ts"
export * from "./DataDiscrepancy.vue?vue&type=script&lang=ts"

import "./DataDiscrepancy.vue?vue&type=style&index=0&id=3700503d&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3700503d"]])

export default __exports__